// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Ld5X","header":"ReportDetails_header__3Rx0u","title":"ReportDetails_title__36ln1","left":"ReportDetails_left__3L1fQ"};